// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';
import MoneyIcon from '@mui/icons-material/Money';
// type
import { NavItemType } from 'types';

const icons = {
    IconDashboard: IconDashboard,
    IconDeviceAnalytics: IconDeviceAnalytics
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const payout: NavItemType = {
    id: 'payout',
    title: <FormattedMessage id="Payouts" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'payout',
            title: 'PayPal Payouts',
            type: 'item',
            icon: MoneyIcon,
            url: '/payouts/list',
            breadcrumbs: false
        }
    ]
};

export default payout;
